module.exports = __webpack_public_path__ + "img/icon_light@2x.dbd1d0db.png";